export function logSentryError(error) {
    if (typeof window.Sentry !== 'undefined') {
        window.Sentry.captureException(error);
    }
}

export function logCaptureMessage(message) {
    if (typeof window.Sentry !== 'undefined') {
        window.Sentry.captureMessage(message);
    }
}